import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fileUrl = (path) => `${API}/files/${path}`;

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Algo salió mal. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (typeof d?.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export const LEVEL_RANK = { free: 0, base: 1, pro: 2 };
export const LEVEL_LABEL = { free: "Gratis", base: "Plan Base", pro: "Plan Pro" };
export const canUse = (user, level = "free") => user?.role === "admin" || (LEVEL_RANK[user?.subscription_level ?? "free"] ?? 0) >= (LEVEL_RANK[level] ?? 0);

export const RISK = {
  Bajo: { label: "Riesgo bajo", color: "#10B981", text: "text-emerald-400", bg: "bg-emerald-500/10", border: "border-emerald-500/40" },
  Medio: { label: "Riesgo medio", color: "#F59E0B", text: "text-amber-400", bg: "bg-amber-500/10", border: "border-amber-500/40" },
  Alto: { label: "Riesgo alto", color: "#F43F5E", text: "text-rose-400", bg: "bg-rose-500/10", border: "border-rose-500/40" },
};
